import { useState, useEffect, useRef } from "react";
import logo from "../../assets/clinique-logo.png";

// ─── NAV DATA ─────────────────────────────────────────────────────────────── 

const branchItems = [
  { label: "Navi Mumbai (Kharghar)", href: "https://hairclinique.in/description.php" },
  { label: "Pune", href: "https://pune.hairclinique.in/" },
  { label: "Bengaluru", href: "/" },
  { label: "Shirdi", href: "https://shirdi.hairclinique.in/" },
];

const more = [
    { label: "Blog", href: "/blog/"},
    { label: "Testimonials", href: "/client-testimonials.php" },
    { label: "Faq", href: "/faq.php" },
]

const htIndiaItems = [
  { label: "Hair Transplant in India", href: "/hair-transplant-in-india.php" },
  { label: "Hair Transplant Cost in India", href: "/hair-transplant-cost-in-india.php" },
  { label: "Hair Transplant Surgery in India", href: "/hair-transplant-surgery-in-india.php" },
  // { label: "Hair Transplant Treatment in Bangalore", href: "/hair-transplant-clinic-surgeon-bangalore-dr-idris.php" }
];

const treatmentsMega = {
  surgical: [
    { label: "About Hair Transplant", href: "/about-hair-transplants.php" },
    { label: "Male Hair Transplant", href: "/male-hair-transplants.php" },
    { label: "Female Hair Transplant", href: "/female-hair-transplants.php" },
    { label: "Beard Hair Transplant", href: "/beard-hair-transplants.php" },
    { label: "Eyebrow Hair Transplant", href: "/eyebrow-hair-transplants.php" },
    { label: "Eyelash Hair Transplant", href: "/eyelash-hair-transplants.php" },
  ],
};

const navLinks = [
  { label: "Home", href: "/" },
  { label: "Description", dropdown: [{ label: "About Us", href: "/description.php" }, { label: "Our Team", href: "/our-Surgeons.php" }] },
  { label: "HT India", dropdown: htIndiaItems },
  { label: "Our Treatments", mega: true },
  { label: "Training", href: "/trainings.php" },
  { label: "More", dropdown: more },
];

// ─── SUB COMPONENTS ─────────────────────────────────────────────────────────

function ChevronIcon({ open }) {
  return (
    <svg
      className={`w-3 h-3 shrink-0 transition-transform duration-200 ${open ? "rotate-180" : ""}`}
      fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
    </svg>
  );
}

function DropdownMenu({ items, isOpen }) {
  return (
    <div
      className={`absolute top-full left-0 mt-0 w-60 z-50 transition-all duration-200 origin-top rounded-b-sm ${
        isOpen ? "opacity-100 scale-y-100 pointer-events-auto" : "opacity-0 scale-y-95 pointer-events-none"
      }`}
      style={{ background: "#110e04", border: "1px solid rgba(201,168,76,0.15)", borderTop: "none" }}
    >
      {items.map((item, i) => (
        <a
          key={i}
          href={item.href}
          className="block px-5 py-3 text-[14px] text-white/80 hover:text-white hover:bg-white/5 transition-colors duration-150 border-b border-white/5 last:border-0"
          style={{ fontFamily: "'Cinzel', serif" }}
        >
          {item.label}
        </a>
      ))}
    </div>
  );
}

function MegaMenu({ isOpen }) {
  return (
    <div
      className={`absolute top-full left-1/2 -translate-x-1/2 w-205 z-50 transition-all duration-200 origin-top rounded-b-sm ${
        isOpen ? "opacity-100 scale-y-100 pointer-events-auto" : "opacity-0 scale-y-95 pointer-events-none"
      }`}
      style={{ background: "#110e04", border: "1px solid rgba(201,168,76,0.15)", borderTop: "none" }}
    >
      <div className="grid grid-cols-3 divide-x divide-white/[0.07] px-2 py-6">
        {/* Surgical */}
        <div className="px-6">
          <h4
            className="text-[13px] font-semibold text-white/40 uppercase tracking-[0.18em] mb-4"
            style={{ fontFamily: "'Cinzel', serif" }}
          >
            Surgical
          </h4>
          {treatmentsMega.surgical.map((item, i) => (
            <a
              key={i}
              href={item.href}
              className="block py-2 text-[14px] text-white/80 hover:text-white transition-colors duration-150"
              style={{ fontFamily: "'Cinzel', serif" }}
            >
              {item.label}
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}

// ─── MAIN NAVBAR ─────────────────────────────────────────────────────────────

export default function Navbar() {
  const [openDropdown, setOpenDropdown] = useState(null);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [mobileExpanded, setMobileExpanded] = useState(null);
  const [scrolled, setScrolled] = useState(false);
  const navRef = useRef(null);
  const timeoutRef = useRef(null);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const onClick = (e) => {
      if (navRef.current && !navRef.current.contains(e.target)) {
        setOpenDropdown(null);
        setMobileOpen(false);
      }
    };
    document.addEventListener("mousedown", onClick);
    return () => document.removeEventListener("mousedown", onClick);
  }, []);

  const enter = (i) => { clearTimeout(timeoutRef.current); setOpenDropdown(i); };
  const leave = () => { timeoutRef.current = setTimeout(() => setOpenDropdown(null), 120); };

  return (
    <>
      <link
        href="https://fonts.googleapis.com/css2?family=Cinzel:wght@400;500;600;700&display=swap"
        rel="stylesheet"
      />

      {/* Shiny gold button keyframes */}
      <style>{`
        @keyframes goldShine {
          0%   { background-position: -200% center; }
          100% { background-position: 200% center; }
        }
        .btn-gold-shine {
          background: linear-gradient(
            105deg,
            #7d5a0a 0%,
            #c9943a 20%,
            #f5d27a 38%,
            #ffe9a0 50%,
            #f5d27a 62%,
            #c9943a 80%,
            #7d5a0a 100%
          );
          background-size: 200% auto;
          animation: goldShine 3s linear infinite;
          color: #1a0f00;
          font-weight: 700;
        }
        .btn-gold-shine:hover {
          animation-duration: 1.2s;
          filter: brightness(1.08);
        }
      `}</style>

      <nav
        ref={navRef}
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? "shadow-md shadow-black/70" : ""}`}
        style={{ background: "linear-gradient(180deg, #0a0800 0%, #0f0c02 100%)" }}
      >
        {/* ── TOP ROW ── */}
        <div className="border-b border-white/[0.07]">
          <div className="max-w-7xl mx-auto px-5 sm:px-8 flex items-center justify-between h-19">

            {/* Logo — bigger, no text */}
            <a href="/" className="flex items-center shrink-0">
              {/*
                Replace below div with your actual logo image:
                <img src={logo} alt="HairClinique" className="h-16 w-auto" />
              */}
              <img src={logo} alt="HairClinique" className="h-16 w-auto" />
            </a>

            {/* Right — desktop */}
            <div className="hidden md:flex items-center gap-3">
              {/* Our Branches selector */}
              <div
                className="relative"
                onMouseEnter={() => enter("branches-top")}
                onMouseLeave={leave}
              >
                <button
                  className="flex items-center gap-2 px-4 py-2 text-white/80 hover:text-white transition-colors"
                  style={{ fontFamily: "'Cinzel', serif" }}
                >
                  <svg className="w-5 h-5 text-[#c9a84c]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
                    <path strokeLinecap="round" strokeLinejoin="round" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path strokeLinecap="round" strokeLinejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                  <span
                    className="text-[14px] tracking-wide"
                    style={{ fontFamily: "'Cinzel', serif" }}
                  >
                    Our Branches
                  </span>
                  <ChevronIcon open={openDropdown === "branches-top"} />
                </button>
                <DropdownMenu items={branchItems} isOpen={openDropdown === "branches-top"} />
              </div>

              {/* Contact Us */}
              <a
                href="/bangalore.php"
                className="px-6 py-2.5 text-[14px] tracking-[0.08em] text-white border border-white/30 hover:border-white/60 rounded-full transition-all duration-200"
                style={{ fontFamily: "'Cinzel', serif" }}
              >
                Contact Us
              </a>

              {/* Get Appointment — shiny gold */}
              <a
                href="tel:+919082123009"
                className="btn-gold-shine flex items-center gap-2 px-6 py-2.5 text-[14px] tracking-[0.08em] rounded-full"
                style={{ fontFamily: "'Cinzel', serif" }}
              >
                <svg className="w-4 h-4 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
                Get Appointment
              </a>
            </div>

            {/* Mobile hamburger */}
            <button
              onClick={() => setMobileOpen(!mobileOpen)}
              className="md:hidden flex flex-col gap-1.25 p-2"
              aria-label="Toggle menu"
            >
              <span className={`block w-6 h-0.5 bg-[#c9a84c] transition-all duration-300 ${mobileOpen ? "rotate-45 translate-y-1.75" : ""}`} />
              <span className={`block w-6 h-0.5 bg-[#c9a84c] transition-all duration-300 ${mobileOpen ? "opacity-0" : ""}`} />
              <span className={`block w-6 h-0.5 bg-[#c9a84c] transition-all duration-300 ${mobileOpen ? "-rotate-45 -translate-y-1.75" : ""}`} />
            </button>
          </div>
        </div>

        {/* ── BOTTOM ROW — Desktop Nav Links ── */}
        <div className="hidden md:block">
          <div className="max-w-7xl mx-auto px-5 sm:px-8">
            <div className="flex items-center gap-0 h-12.5">
              {navLinks.map((link, i) => (
                <div
                  key={i}
                  className="relative"
                  onMouseEnter={() => enter(i)}
                  onMouseLeave={leave}
                >
                  {link.dropdown || link.mega ? (
                    <button
                      className="flex items-center gap-1.5 px-5 py-2 text-[15px] text-white/80 hover:text-white transition-colors duration-150 whitespace-nowrap"
                      style={{ fontFamily: "'Cinzel', serif", letterSpacing: "0.06em" }}
                    >
                      {link.label}
                      <ChevronIcon open={openDropdown === i} />
                    </button>
                  ) : (
                    <a
                      href={link.href}
                      className="flex items-center px-5 py-2 text-[15px] text-white/80 hover:text-white transition-colors duration-150 whitespace-nowrap"
                      style={{ fontFamily: "'Cinzel', serif", letterSpacing: "0.06em" }}
                    >
                      {link.label}
                    </a>
                  )}

                  {link.dropdown && <DropdownMenu items={link.dropdown} isOpen={openDropdown === i} />}
                  {link.mega && <MegaMenu isOpen={openDropdown === i} />}
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* ── MOBILE MENU ── */}
        <div
          className={`md:hidden overflow-y-auto transition-all duration-300 border-t border-white/[0.07] ${
            mobileOpen ? "max-h-[80vh] opacity-100" : "max-h-0 opacity-0"
          }`}
          style={{ background: "#0a0800" }}
        >
          <div className="px-5 py-3 space-y-0.5">


{/* Mobile Our Branches */}
<div className="border-b border-white/[0.07]">
  <button
    onClick={() =>
      setMobileExpanded(
        mobileExpanded === "branches"
          ? null
          : "branches"
      )
    }
    className="w-full flex items-center justify-between px-3 py-3.5 text-[15px] text-white/80 hover:text-white transition-colors"
    style={{
      fontFamily: "'Cinzel', serif",
      letterSpacing: "0.05em",
    }}
  >
    <span className="flex items-center gap-2">
      <svg
        className="w-5 h-5 text-[#c9a84c]"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={1.8}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
        />
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
        />
      </svg>
      Our Branches
    </span>

    <ChevronIcon
      open={mobileExpanded === "branches"}
    />
  </button>

  <div
    className={`overflow-hidden transition-all duration-200 ${
      mobileExpanded === "branches"
        ? "max-h-60"
        : "max-h-0"
    }`}
  >
    <div className="pl-4 border-l border-[#c9a84c]/20 ml-3 mb-2">
      {branchItems.map((item, i) => (
        <a
          key={i}
          href={item.href}
          className="block px-3 py-2.5 text-[13px] text-white/65 hover:text-white transition-colors"
          style={{ fontFamily: "'Cinzel', serif" }}
          onClick={() => setMobileOpen(false)}
        >
          {item.label}
        </a>
      ))}
    </div>
  </div>
</div>


            {navLinks.map((link, i) => {
              const items = link.mega
                ? [
                    ...treatmentsMega.surgical,
                  ]
                : link.dropdown;

              return (
                <div key={i}>
                  {items ? (
                    <>
                      <button
                        onClick={() => setMobileExpanded(mobileExpanded === i ? null : i)}
                        className="w-full flex items-center justify-between px-3 py-3.5 text-[15px] text-white/80 hover:text-white transition-colors"
                        style={{ fontFamily: "'Cinzel', serif", letterSpacing: "0.05em" }}
                      >
                        {link.label}
                        <ChevronIcon open={mobileExpanded === i} />
                      </button>
                      <div
                        className={`overflow-hidden transition-all duration-200 ${
                          mobileExpanded === i ? "max-h-125" : "max-h-0"
                        }`}
                      >
                        <div className="pl-4 border-l border-[#c9a84c]/20 ml-3 mb-2">
                          {items.map((item, j) => (
                            <a
                              key={j}
                              href={item.href}
                              className="block px-3 py-2.5 text-[13px] text-white/55 hover:text-white/90 transition-colors"
                              style={{ fontFamily: "'Cinzel', serif" }}
                            >
                              {item.label}
                            </a>
                          ))}
                        </div>
                      </div>
                    </>
                  ) : (
                    <a
                      href={link.href}
                      className="block px-3 py-3.5 text-[15px] text-white/80 hover:text-white transition-colors"
                      style={{ fontFamily: "'Cinzel', serif", letterSpacing: "0.05em" }}
                      onClick={() => setMobileOpen(false)}
                    >
                      {link.label}
                    </a>
                  )}
                </div>
              );
            })}

            {/* Mobile CTAs */}
            <div className="pt-4 pb-3 flex flex-col gap-3 border-t border-white/[0.07] mt-2">
              <a
                href="#contact"
                className="text-center py-3 text-[14px] tracking-[0.08em] text-white border border-white/30 rounded-full"
                style={{ fontFamily: "'Cinzel', serif" }}
              >
                Contact Us
              </a>
              <a
                href="#appointment"
                className="btn-gold-shine flex items-center justify-center gap-2 py-3 text-[14px] tracking-[0.08em] rounded-full"
                style={{ fontFamily: "'Cinzel', serif" }}
              >
                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
                Get Appointment
              </a>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
}